import svg from "./fractions-icon.svg?react";
import { makeSvgIcon } from "./svg-icon";

export const FractionsIcon = makeSvgIcon(svg);

export default FractionsIcon;
